import React from 'react'
import { connect } from 'react-redux'

class AssetAccPrintDiv extends React.Component {
  state = {}
  componentDidMount = () => {

    Tyan.doPostEvent({
      event: 'GetAssetAccPrint',
      data: { },
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ id, initValues基本信息, changedValues基本信息: {} })
        }
      }
    })
  }

  handlerConfirm = () => {
    const { initValues基本信息, changedValues基本信息 } = this.state
    const { onSave, onClose } = this.props

    Tyan.doPostEvent({
      event: 'SaveAssetAccPrint',
      data: {
        changedValues基本信息,
      },
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else {
          Ext.toast('保存成功')
          onSave && onSave()
          onClose && onClose()
        }
      }
    })
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  canSave = () => {
    const { initValues基本信息, changedValues基本信息, id } = this.state
    return Object.keys(changedValues基本信息).length > 0 || id < 0
  }

  fieldset基本信息 = () => {
    return [
      { _text: '模板内容', name: '模板内容', minWidth: '1000px', maxRows: 30 },
    ]
  }

  render() {
    const { showMessage: Message, showBody: Body, id } = this.props
    const { initValues基本信息, changedValues基本信息 } = this.state
    if (!initValues基本信息) return <Message text={'请稍等 ...'} />
    const canSave = this.canSave()
    return <Body data={this} maxWidth="1100"
      controls={
        [
          { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
          { _button: '关闭', icon: 'close', handler: this.handlerClose },
        ]}
      fieldsets={
        [
          { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
        ]}
    />
  }
}

export default connect()(AssetAccPrintDiv)